






























import { Component, Vue } from "vue-property-decorator";
import DashboardTemplate from "@/views/Layouts/dashboard-template.vue";

@Component({
  components: {
    DashboardTemplate
  },
})
export default class GroupsWiki extends Vue {}
